import {ref} from 'vue';
import * as planApi from "@/api/plans/plans";

export function usePlan() {
    const plans = ref([]);
    const plan = ref(null);
    
    const loadingPlan = ref(false);
    const isSuccessPlan = ref(false);
    const messagePlanSuccess = ref('');
    const messagePlanError = ref('');
    
    function setSuccess(msg) {
        messagePlanSuccess.value = msg;
        isSuccessPlan.value = true;
    }
    
    function setError(msg) {
        messagePlanError.value = msg;
        isSuccessPlan.value = false;
    }
    
    async function load(pageArg = 1, sizeArg = 100) {
        loadingPlan.value = true;
        try {
            const data = await planApi.listPlans(pageArg, sizeArg);
            plans.value = data.content;
        } catch (e) {
            setError('Не удалось загрузить');
        } finally {
            loadingPlan.value = false;
        }
    }
    
    async function detailPlan(planId) {
        loadingPlan.value = true;
        try {
            plan.value = await planApi.detailPlan(planId);
        } catch (e) {
            setError('Не удалось загрузить');
        } finally {
            loadingPlan.value = false;
        }
    }
    
    async function sortPlans(payload) {
        loadingPlan.value = true;
        try {
            await planApi.sortPlans(payload);
            setSuccess('Сортировка обновлена');
        } catch (e) {
            setError('Не удалось обновить сортировку');
        } finally {
            loadingPlan.value = false;
        }
    }
    
    async function addPlan(payload) {
        loadingPlan.value = true;
        try {
            await planApi.createPlan(payload);
            setSuccess('План добавлен');
        } catch (e) {
            setError('Не удалось сохранить план, попробуйте снова');
            if (e?.code === "plan_wrong_dates") setError("Неверный диапазон дат");
        } finally {
            loadingPlan.value = false;
        }
    }
    
    async function updatePlan(id, payload) {
        loadingPlan.value = true;
        try {
            await planApi.updatePlan(id, payload);
            setSuccess('План сохранен');
            await load();
        } catch (e) {
            setError('Не удалось сохранить план, попробуйте снова');
            if (e?.code === "plan_wrong_dates") setError("Неверный диапазон дат");
        } finally {
            loadingPlan.value = false;
        }
    }
    
    async function deletePlan(id) {
        try {
            await planApi.deletePlan(id);
            setSuccess('План удален');
            await load();
        } catch (e) {
            setError('Не удалось удалить план');
        }
    }
    
    return {
        plans,
        plan,
        loadingPlan,
        
        isSuccessPlan,
        messagePlanSuccess,
        messagePlanError,
    
        load,
        detailPlan,
        addPlan,
        updatePlan,
        deletePlan,
        sortPlans
    };
}

export function getScopeTypeName(plan)
{
    return plan.scopeType === 'TOTAL' ? 'Все изменения' : 'Только категории'
}

export function getTypeName(plan)
{
    return plan.type === 'EXPENSE' ? 'Расход' : 'Накопления'
}

export function getProgressBar(plan)
{
    const transactionAmount = plan.scopeType === 'TOTAL' ? plan.totalTransactionsAmount : plan.categoriesTransactionsAmount;
    const amount = plan.scopeType === 'TOTAL' ? plan.amount : plan.amount;
    const percent = Math.round(amount > 0 ? (transactionAmount / amount) * 100 : 0);
    const remainingAmount = Number((amount - transactionAmount).toFixed(2));
    return {
        amount: amount,
        transactionAmount: transactionAmount,
        isOverAmount: (amount - transactionAmount) < 0,
        remainingAmount: remainingAmount,
        percent: percent,
    };
}

export function getChartVerticalBarElements(plan) {
    let amountPlanItems = 0;
    let amountFactItems = 0;
    const elements = plan.planItems.map(item => {
        amountPlanItems += item.amount;
        amountFactItems += item.transactionsAmount;
        return {
            name: item.categoryName,
            plan: item.amount,
            fact: item.transactionsAmount,
            currency: plan.accountCurrency,
        };
    }) ?? [];
    if (plan.scopeType === 'TOTAL') {
        const amountPlanOther = plan.amount - amountPlanItems;
        const amountFactOther = plan.totalTransactionsAmount - amountFactItems;
        if (amountFactOther > 0) {
            elements.push({
                name: "Прочие",
                plan: amountPlanOther,
                fact: amountFactOther,
                currency: plan.accountCurrency,
            });
        }
    }
    
    return elements;
}

export function getScopeTypes() {
    return [
        {
            name: "Все изменения",
            id: "TOTAL"
        },
        {
            name: "Только категории",
            id: "CATEGORIES"
        },
    ];
}

export function getTypes() {
    return [
        {
            name: "Расходы",
            id: "EXPENSE"
        },
        {
            name: "Накопления",
            id: "INCOME"
        },
    ];
}
